import React, { FC } from 'react';
import { NavDemo } from '../demo/nav/NavDemo';
import { NavCustomerButton } from './customers/NavCustomerButton';
import { NavFeaturesButton } from './features/NavFeaturesButton';
import { NavLoginButton } from './login/NavLoginButton';
import { NavPublicPricing } from './pricing/NavPublicPricing';
import { NavSignupButton } from './signup/NavSignupButton';
import { Nav } from './components/Nav';

type Props = {
  hideDemo?: boolean;
};

export const NavPublic: FC<Props> = ({ hideDemo }) => {
  return (
    <Nav dataTestId="nav-public">
      {!hideDemo && <NavDemo />}
      <NavFeaturesButton />
      <NavCustomerButton />
      <NavPublicPricing />
      <NavLoginButton />
      <NavSignupButton />
    </Nav>
  );
};
